import React, { lazy } from "react";
import { useParams } from "react-router-dom";

//const TikTokHashtagGenerator = lazy(() => import("./Pages/TikTokHashtagGenerator"));
const TikTokHashtagGenerator = lazy(
  () => import("./Pages/HashtagGenerators/TiktokHashtagGenerator")
);
const TwitterHashtagGenerator = lazy(
  () => import("./Pages/HashtagGenerators/TwitterHashtagGenerator")
);

const FacebookHashtagGenerator = lazy(
  () => import("./Pages/HashtagGenerators/FacebookHashtagGenerator")
);

const YoutubeHashtagGenerator = lazy(
  () => import("./Pages/HashtagGenerators/YoutubeHashtagGenerator")
);

const LinkedInHashtagGenerator = lazy(
  () => import("./Pages/HashtagGenerators/LinkedInHashtagGenerator")
);

export default function NewHashTagGenerator() {
  let { slug } = useParams();

  switch (slug) {
    case "tiktok":
      return <TikTokHashtagGenerator />;
    case "twitter":
      return <TwitterHashtagGenerator />;
    case "facebook":
      return <FacebookHashtagGenerator />;
    case "youtube":
      return <YoutubeHashtagGenerator />;
    case "linkedin":
      return <LinkedInHashtagGenerator />;
    default:
      return null;
  }
}
